import { useLanguage } from "../../context/LanguageContext";
import { StepNav } from "./OrderControls";
const FIELDS = [
  { name: "first_name", id: "first-name", label: "First name", placeholder: "Eva", type: "text" },
  { name: "last_name", id: "last-name", label: "Last name", placeholder: "Muster", type: "text" },
  { name: "email", id: "email", label: "Email", placeholder: "eva@example.ch", type: "email" },
  { name: "phone", id: "phone", label: "Phone number", placeholder: "+41 79 000 00 00", type: "tel" },
];
export const ContactStep = ({ order }) => {
  const { t } = useLanguage();
  const { form, set, setStep } = order;
  const valid = form.first_name.trim() && form.last_name.trim() && /.+@.+\..+/.test(form.email) && form.phone.trim();
  return <div>
    <h2 className="font-display text-xl font-semibold text-slate-100">{t("Your contact details")}</h2>
    <div className="mt-6 grid gap-5 sm:grid-cols-2">{FIELDS.map(field => <div key={field.name}>
      <label className="studio-label" htmlFor={field.id}>{t(field.label)}</label>
      <input id={field.id} data-testid={`order-step-1-${field.id}-input`} type={field.type} className="studio-input" value={form[field.name]} onChange={set(field.name)} placeholder={field.placeholder} />
    </div>)}</div>
    <StepNav onBack={() => setStep(0)} onNext={() => setStep(2)} nextDisabled={!valid} />
  </div>;
};